import defaultLogoUrl from '../../../../media/logo_couleur_contour.svg';
import { __ } from '../utils/i18n';

type HubAccessBlockedProps = {
  message: string;
  onRetry: () => void;
  logoUrl?: string;
};

const HubAccessBlocked = ({ message, onRetry, logoUrl }: HubAccessBlockedProps) => {
  const src = logoUrl && logoUrl.length > 0 ? logoUrl : defaultLogoUrl;

  return (
    <div className="hub-access-blocked" role="status">
      <img src={src} alt="" className="hub-access-blocked__logo" width={200} height={64} />
      <p className="hub-access-blocked__message">{message}</p>
      <button type="button" className="btn-secondary" onClick={onRetry}>
        {__('Réessayer')}
      </button>
    </div>
  );
};

export default HubAccessBlocked;
